<template>
  <div class="language-selector">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-img :src="flag"
               height="20"
               width="40"
               contain
               v-on="on"
        >
        </v-img>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in availableLanguages"
          :key="index"
          @click="changeLanguage(item.value)"
        >
          <v-img :src="item.flag"
                 height="20"
                 width="40"
                 contain
          >
          </v-img>
          <v-list-item-title class="ml-2">{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
  export default {
    name: 'LanguageSelector',
    computed: {
      flag: function () {
        if (this.currentLanguage === 'en') {
          return this.uk
        }
        return this.de
      }
    },
    data() {
      return {
        availableLanguages: [
          { flag: require('../assets/de.svg'), value: 'de', text: 'German' },
          { flag: require('../assets/uk.svg'), value: 'en', text: 'English' }
        ],
        currentLanguage: 'de',
        de: require('../assets/de.svg'),
        uk: require('../assets/uk.svg')
      }
    },
    mounted() {
      this.currentLanguage = this.$cookies.get('language')
      this.changeLanguage(this.currentLanguage)
    },
    methods: {
      changeLanguage(val) {
        this.$i18n.locale = val
        this.$cookies.set('language', val)
        this.currentLanguage = val
      },
      getNavigatorLanguage() {
        if (navigator.languages && navigator.languages.length) {
          return navigator.languages[0]
        } else {
          return navigator.language || 'de-DE'
        }
      }
    }
  }
</script>
<style scoped>
  .language-selector {
    color: #000;
    cursor: pointer;
  }

  .language-selector /deep/ .v-toolbar__title {
    font-weight: normal;
    font-size: 17px;
    color: #fff;
  }

  .v-list__tile__title {
    color: #000;
  }

  .active {
    color: #649FDF;
  }

  .m-item {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
</style>